<script lang="ts">
    import type { NetworkResponse } from "../../../../../../admin-service-typescript-client";
    import { locationStore } from "../../../../../store/locations";

    export let network: NetworkResponse;
</script>

<div class="card-content no-padding ">
    <div class="content small-padding">
        {#if network}
            <div class="flex">
                <div class="row centered">
                    <div class="header">{network.name}</div>
                </div>
                <div class="row">
                    <div class="left">Status:</div>
                    <div class="right">
                        {network.active ? "aktiv" : "deaktiv"}
                    </div>
                </div>
                <div class="row">
                    <div class="left">Locations:</div>
                    <div class="right">
                        {#if $locationStore.locations?.totalElements}
                            {$locationStore.locations.totalElements}
                        {/if}
                    </div>
                </div>
            </div>
        {:else}
            <div class="fa-3x">
                <i class="fas fa-spinner fa-pulse" />
            </div>
        {/if}
    </div>
</div>

<style>
    .text-left {
        text-align: left;
        table-layout: fixed;
    }

    .text-left th,
    .text-left td {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .small-padding {
        padding: 0.1rem;
    }
    .row {
        width: 100%;
        display: flex;
        padding: 0.5rem;
        justify-content: space-between;
    }

    .centered {
        justify-content: center;
    }

    .header {
        font-size: large;
        font-weight: bold;
    }

    .flex {
        display: flex;
        flex-direction: column;
    }
</style>
